import * as React from 'react';
import { PriceSortQueryValue } from '@packages/common';
import { RefinementsContext } from '../RefinementsContext';
import { priceSort$ } from './refinementsEvents';

export const usePriceSorting = () => {
  const { setRefinements, refinements } = React.useContext(RefinementsContext);
  const updatePriceSorting = React.useMemo(
    () => (priceSort: PriceSortQueryValue) => {
      setRefinements((refinements) => ({
        ...refinements,
        page: 0,
        priceSort,
      }));

      priceSort$.next(priceSort);
    },
    [setRefinements],
  );

  const priceSort = refinements.priceSort || PriceSortQueryValue.NONE;

  return { updatePriceSorting, priceSort };
};
